import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { HERO_IMG } from "@/components/landing/landingData";

export const COMPANY = "Quantum Sports Intelligence LLC";
export const EFFECTIVE = "October 21, 2026";

export const LegalLinks = ({ className = "" }) => (
  <span className={`inline-flex gap-4 ${className}`}>
    <Link data-testid="link-privacy" to="/privacy" className="hover:text-cyan-300">Privacy Policy</Link>
    <Link data-testid="link-terms" to="/terms" className="hover:text-cyan-300">Terms of Service</Link>
  </span>
);

export const LegalPage = ({ title, testid, children }) => {
  useEffect(() => { window.scrollTo(0, 0); document.title = `${title} · Hat Trick`; }, [title]);
  return (
    <div data-testid={testid} className="dark min-h-screen bg-[#03050A] text-slate-300">
      <header className="border-b border-white/5 bg-[#03050A]/80 backdrop-blur-xl">
        <div className="mx-auto flex h-16 max-w-4xl items-center justify-between px-4 sm:px-6">
          <Link to="/" data-testid="legal-home-link" aria-label="Hat Trick home"><img src={HERO_IMG} alt="QSI HAT TRICK" className="h-10 w-auto rounded-md object-contain" /></Link>
          <LegalLinks className="font-mono text-[11px] uppercase tracking-[0.15em] text-slate-400" />
        </div>
      </header>
      <main className="mx-auto max-w-4xl px-4 py-14 sm:px-6">
        <p className="font-mono text-[11px] uppercase tracking-[0.35em] text-[#22D3EE]">Legal</p>
        <h1 className="mt-3 font-condensed text-4xl font-extrabold uppercase tracking-tight text-white sm:text-5xl">{title}</h1>
        <p className="mt-2 font-mono text-[11px] uppercase tracking-wider text-slate-500">Effective {EFFECTIVE} · {COMPANY}</p>
        <div className="legal-body mt-10 space-y-8 text-[15px] leading-relaxed">{children}</div>
        <Link to="/" data-testid="legal-back" className="mt-14 inline-block font-mono text-[11px] font-bold uppercase tracking-[0.2em] text-[#22D3EE] hover:text-white">← Back to Hat Trick</Link>
      </main>
    </div>
  );
};

export const Sec = ({ n, title, children }) => (
  <section>
    <h2 className="font-condensed text-2xl font-bold uppercase tracking-wide text-white">{n}. {title}</h2>
    <div className="mt-3 space-y-3">{children}</div>
  </section>
);

export const Ul = ({ items }) => (
  <ul className="list-disc space-y-1.5 pl-5 marker:text-[#22D3EE]">{items.map((t) => <li key={t}>{t}</li>)}</ul>
);
